import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
// import { Select, MenuItem } from '@material-ui/core'
// import { withStyles } from '@material-ui/core/styles'
// import LockOpen from '@material-ui/icons/LockOpen'
// import Lock from '@material-ui/icons/Lock'
import { Select, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import LockOpen from '@mui/icons-material/LockOpen';
import moment from 'moment'
import Lock from '@mui/icons-material/Lock';
import { markerCreateRequest, markerUpdateRequest, markerDeleteRequest } from '../../../../../action/marker-actions'
import Elevation from '../../../../../lib/api/elevation'
import { markerTypes25FetchRequest } from '../../../../../action/marker-types-25-actions'
import { expandLeftToolbar, collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { enableMapObject, disableMapObject } from '../../../../../action/disable-map-obj-state-action'
import { weatherData } from '../../../../../action/weather-action'
import { weatherUpdate } from '../../../../../action/weather-action'
import isNil from 'lodash/isNil'
import ExtendedData from './extended-data'
import { blockFeatures, unBlockFeatures } from '../../../../../action/features-blocked-actions'
import ConfirmRemoval from '../confirm-removal'
import { ColorCodes, ArrayData, icons, styleData } from './dummy'
import standIcon from '../../../../../../asset/stand-icon.png'
import standIconWhite from '../../../../../asset/Tree_Stand_White.png'
import rightIcon from '../../../../../asset/rightIcon.png'
import downIcon from '../../../../../../asset/down.png'
import DiscardChanges from './discard-changes'
import { removeCenterMarker } from '../../../../../action/center-marker-action'
import { decimalToDMS, dateConvertion } from '../../../../main-ui/common/commonfunctions'
import { renderInfoBox } from '../../../../../../src/component/map/render-photos/listner'
import { toNumber } from 'lodash'
import { throttle } from '../reusable-function'
import { markerGroupsFetchRequest } from '../../../../../action/marker-group-actions'

const MarkerSelectItem = withStyles((theme) => ({
  root: {
    border: '1px solid #959595'
  },
  selected: {
    color: 'black'
  }
}))(MenuItem)

class MarkerDetails extends React.Component {
  constructor(props) {
    super(props)
    const { editable } = props.leftToolbarState
    this.type = this.props.type
    this.categories = props.category ? props.markerGroups.filter(group => group.id === props.category)
      : [{
        id: 0,
        order: 0,
        name: 'All Categories',
        markerType: props.markerTypes35
      }].concat(props.markerGroups)
    if (props.usageFlag) {
      this.categories[0].markerType = this.categories[0].markerType.filter(type => type.usageFlag === props.usageFlag)
    }
    this.state = {
      editableData: editable,
      altitude: 0,
      latitude: '',
      longitude: '',
      markerTypeId: props.usageFlag ? 88 : 134,
      name: this.type == 'addStand' || editable && (editable.markerType.usageFlag == 3) ? `Hunt Stand - ${props.huntStands.length}` : `Marker - ${props.markers.length}`,
      notes: '',
      category: this.categories[0],
      locationSet: props.leftToolbarState.editable ? true : false,
      confirmRemoval: false,
      openStyleIcon: false,
      selectedMarkerIcon: 'https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/small35/Green.png',
      selectAnimalIcon: editable ? editable.markerType.vectorIconUrl ? editable.markerType.vectorIconUrl : editable.markerType.iconUrl : this.props.type === 'addStand' ? 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Ground%20Blind%29.svg' : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg',
      filterItems: '',
      colorMarker: editable ? editable.color : '9ECC3B',
      makeEmpty: false,
      selectedStyle: this.type == 'addStand' || editable && (editable.markerType.usageFlag == 3) ? 'Hunt Stands' : 'Recent',
      iconImageUrl: null,
      markerColor: null,
      unMountComponent: true,
      discardPopUp: false,
      typeOfProp: 'Not Updated',
      usageFlag: props.usageFlag,
      weatherData: null,
      updatedDate: '',
      createdDate: '',
      locationName: this.type == 'addStand' || editable && (editable.markerType.usageFlag == 3) ? 'Stand (Blind)' : 'Location',
      loadSpinner: false,
      recentUsedMarkers: []
    }
    this.marker = null
    this.moveListener = null
    this.clickListener = null
    this.createmarkerOptions = null
    this.latitudeRef = React.createRef()
    this.longitudeRef = React.createRef()
    this.advanceMarker = null
    this.saveMarker = throttle(this.saveMarker.bind(this), 15000); // Throttle for 2 seconds
  }

  componentDidMount() {
    const { editable, mapObj } = this.props.leftToolbarState
    if (this.type != 'addStand') {
      this.recentUsedMarkers()
    }
    this.props.markerGroupsFetchRequest()
    if (editable) {
      if (editable && !editable.SharedMarker) {
        const markerDetails = Object.assign(this.state, editable)
        this.setState({ selectAnimalIcon: markerDetails.markerType.vectorIconUrl, colorMarker: markerDetails.color, usageFlag: markerDetails.markerType.usageFlag })
        markerDetails['category'] = this.categories.find(cat => cat.id === markerDetails.markerType.markerGroupId)
        this.setState({
          markerDetails,
          latitude: markerDetails.latitude.toFixed(6),
          longitude: markerDetails.longitude.toFixed(6),
          typeOfProp: ((editable.markerType.usageFlag == 3)) ? 'addStand' : '',
          selectedStyle: this.type == 'addStand' || editable && (editable.markerType.usageFlag == 3) ? 'Hunt Stands' : 'Recent',
          locationName: markerDetails.markerType.name
        }, () => {
          this.advanceMarker = editable.mapObj()
          if (mapObj != null) {
            google.maps.event.removeListener(mapObj)
          }
          this.latitude = parseFloat(markerDetails.latitude).toFixed(6);
          this.longitude = parseFloat(markerDetails.longitude).toFixed(6);
          let createdDate = dateConvertion(editable.created)
          let updatedDate = dateConvertion(editable.updated)
          this.setState({ createdDate, updatedDate })
        })
      }
      else if (editable && editable.SharedMarker) {
        const markerDetails = Object.assign(this.state, editable)
        const decodedNValue = markerDetails.markerName ? decodeURIComponent(markerDetails.markerName).split(' ')[0] : null;
        this.setState({ colorMarker: markerDetails.color })
        this.setState({
          markerDetails,
          latitude: parseFloat(markerDetails.latitude).toFixed(6),
          longitude: parseFloat(markerDetails.longitude).toFixed(6),
          typeOfProp: ((editable.markerType.usageFlag == 3)) ? 'addStand' : '',
          selectAnimalIcon: editable.markerType.vectorIconUrl
        }, () => {
          this.advanceMarker = editable.mapObj()
          this.latitude = parseFloat(markerDetails.latitude).toFixed(6);
          this.longitude = parseFloat(markerDetails.longitude).toFixed(6);
          const img = new Image();
          img.src = this.state.selectAnimalIcon;
          img.onerror = () => {
            this.setState({
              selectAnimalIcon: 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'
            });
          };
        })
      }
    } else {
      //make new marker
      const { mapReference, markerTypes25, markerCenter, removeCenterMarker } = this.props
      if (markerCenter && markerCenter.markerObj) {
        markerCenter && markerCenter.markerObj && markerCenter.markerObj.setMap(null)
        this.latitude = parseFloat(markerCenter.coords.latitude).toFixed(6);
        this.longitude = parseFloat(markerCenter.coords.longitude).toFixed(6);
        this.setState({
          locationSet: true,
          latitude: this.latitude,
          longitude: this.longitude
        })
        removeCenterMarker()
      } else {
        this.latitude = mapReference.getCenter().lat()
        this.longitude = mapReference.getCenter().lng()
        this.setState({
          locationSet: true,
          latitude: this.latitude.toFixed(6),
          longitude: this.longitude.toFixed(6)
        })
      }
      const createMarkerFunction = async () => {
        let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        const markerOptions = {
          map: mapReference,
          content: this.buildContent(this.state.selectAnimalIcon, this.state.colorMarker),
          position: { lat: toNumber(this.latitude), lng: toNumber(this.longitude) },
        };
        removeCenterMarker()
        this.advanceMarker = new AdvancedMarkerElement(markerOptions)
      }
      createMarkerFunction()
      this.addMouseHandlers()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { editable, mapObj } = this.props.leftToolbarState;
    const prevEditable = prevProps.leftToolbarState.editable
    if (editable !== prevEditable) {
      this.advanceMarker.position = { lat: prevEditable.latitude, lng: prevEditable.longitude }
      const markerDetails = Object.assign(this.state, editable)
      markerDetails['category'] = this.categories.find(cat => cat.id === markerDetails.markerType.markerGroupId)
      this.setState({
        ...markerDetails,
        selectAnimalIcon: markerDetails.markerType.vectorIconUrl,
        colorMarker: markerDetails.color,
        typeOfProp: (editable.markerType.usageFlag == 3) ? "addStand" : '',
        selectedStyle: this.type == 'addStand' || editable && (editable.markerType.usageFlag == 3) ? 'Hunt Stands' : 'Recent',
        editableData: markerDetails,
      }, () => {
        this.advanceMarker = editable.mapObj();
        if (mapObj != null) {
          google.maps.event.removeListener(mapObj)
        }
        this.latitude = markerDetails.latitude
        this.longitude = markerDetails.longitude
      });
    }
  }

  buildContent = (url, color) => {
    let colorMarker
    const hasSpaces = url && url.includes(' ');
    const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
    if (color) {
      if (color.length <= 6 || color.length <= 7) {
        colorMarker = color[0] == '#' ? color : '#' + color
      } else {
        colorMarker = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
      }
    } else {
      colorMarker = '#9ECC3B'
    }
    const content = document.createElement("div");
    content.innerHTML = `
        <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Define the clipping path for the circle -->
            <defs>
                <clipPath id="circleClip">
                    <circle cx="8" cy="6" r="5" />
                </clipPath>
            </defs>
            <rect width="16" height="16" id="icon-bound" fill="none"></rect>
            <path
                d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                fill=${colorMarker}></path>
            <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
            <!-- Image inside the circle with clipping path -->
            <image xlink:href=${imageUrl ? imageUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'}
             x="4" y="1.5" width="8" height="9" clip-path="url(#circleClip)"></image>
        </svg>
        `;
    return content;
  }

  componentWillUnmount() {
    let { mapReference, infoWindow, openInfoWindowClose, auth } = this.props
    let token = auth.token
    this.removeMouseHandlers()
    let markerData = this.props.leftToolbarState.editable;
    if (this.props.leftToolbarState.editable && !this.state.unMountComponent) {
      this.advanceMarker.addListener('click', () => {
        renderInfoBox(mapReference, this.advanceMarker, markerData, infoWindow, openInfoWindowClose, token, "Marker");
      })
    }
    if (!this.props.leftToolbarState.editable && this.advanceMarker) {
      this.advanceMarker.map = null
    }
    if (this.props.leftToolbarState.editable && this.state.unMountComponent && !this.props.leftToolbarState.editable.SharedMarker) {
      this.advanceMarker.position = { lat: parseFloat(this.props.leftToolbarState.editable.latitude), lng: parseFloat(this.props.leftToolbarState.editable.longitude) }
      this.advanceMarker.content = this.buildContent(this.props.leftToolbarState.editable.markerType.vectorIconUrl,
        this.props.leftToolbarState.editable.color)
      this.props.mapReference.setCenter({ lat: parseFloat(this.props.leftToolbarState.editable.latitude), lng: parseFloat(this.props.leftToolbarState.editable.longitude) })
      this.setState({ discardPopUp: false, unMountComponent: true, typeOfProp: 'Not Updated', selectedStyle: this.type == 'addStand' || this.props.leftToolbarState.editable && ((this.props.leftToolbarState.editable.markerType.usageFlag == 3)) ? 'Hunt Stands' : 'Recent', })
      this.advanceMarker.addListener('click', () => {
        renderInfoBox(mapReference, this.advanceMarker, markerData, infoWindow, openInfoWindowClose, token, "Marker");
        this.advanceMarker.removeListener('click');
      })
    }
    this.marker = null
    if (!this.props.leftToolbarState.editable) {
      this.advanceMarker ? this.advanceMarker.map = null : ''
    }
    this.props.enableMapObject()
  }

  saveMarker() {
    const hasCoords = this.state.latitude && this.state.longitude ? true : false
    this.setState({ loadSpinner: true })
    if (this.state.locationSet || hasCoords) {
      const { leftToolbarState, user, markerTypes25, markerUpdateRequest, markerCreateRequest, collapseLeftToolbar, enableMapObject, mapReference } = this.props;
      const { altitude, latitude, longitude, name, notes, markerTypeId, selectAnimalIcon } = this.state;
      const markerType = markerTypes25.find(type => type.id === this.state.markerTypeId);
      const userId = user.id;
      const toSave = {
        altitude,
        name,
        notes,
        latitude: this.props.type === "addStand" ? this.latitude : latitude,
        longitude: this.props.type === "addStand" ? this.longitude : longitude,
        userId,
        markerTypeId,
        color: this.state.colorMarker,
        markerType: {
          iconUrl: selectAnimalIcon,
          name: markerType.name,
          vectorIconUrl: selectAnimalIcon,
          usageFlag: this.props.type === "addStand" || this.state.typeOfProp === "addStand" ? this.state.usageFlag : this.state.markerTypeId,
        },
        public: false
      }
      this.setState({ locationSet: false }, async () => {
        if (!isNil(leftToolbarState.editable) && !leftToolbarState.editable.SharedMarker) {
          toSave.id = leftToolbarState.editable.id
          if (leftToolbarState.editable.extendedData) {
            toSave.extendedData = leftToolbarState.editable.extendedData
          }

          await markerUpdateRequest(toSave)
            .then((res) => {
              this.setState({ unMountComponent: false });
              this.advanceMarker.title = res.name;
              this.setState({ loadSpinner: true })
              collapseLeftToolbar()
            })
            .catch((err) => {
              console.log('Could not save marker', err)
              collapseLeftToolbar()
            })
        } else {
          if (this.type == 'addStand') {
            mapReference.setCenter({ lat: this.latitude, lng: this.latitude })
            mapReference.setZoom(17)
            this.props.setMarkerData(toSave)
          } else {
            await markerCreateRequest(toSave)
              .then((res) => {
                if (this.props.leftToolbarState && this.props.leftToolbarState.editable && this.props.leftToolbarState.editable.SharedMarker) {
                  this.advanceMarker ? this.advanceMarker.map = null : ''
                }
                collapseLeftToolbar();
                enableMapObject();
                this.setState({ makeEmpty: true });
                this.setState({ loadSpinner: true })
              })
              .catch((err) => {
                console.error('Could not save marker', err);
                collapseLeftToolbar()
              });
          }
        }
      })
    }
  }

  filterIconData(value) {
    const array = ArrayData.filter((item) => item.markerGroupId === value.id);
    this.setState({ filterItems: array })
  }

  addMouseHandlers() {
    if (this.props.disableMapObj) {
      this.props.disableMapObject()
    }
    else {
      this.props.enableMapObject()
    }
    const { blockFeatures, mapReference, token, weatherUpdate } = this.props
    blockFeatures()
    mapReference.setOptions({ draggableCursor: 'crosshair' })
    this.moveListener = mapReference.addListener('mousemove', (e) => {
      if (!this.state.locationSet) {
        this.setState({ locationSet: false })
      }
      const lat = Math.round(e.latLng.lat() * 1000000) / 1000000,
        lng = Math.round(e.latLng.lng() * 1000000) / 1000000
      if (this.latitudeRef.current && this.longitudeRef.current) {
        this.latitudeRef.current.value = this.props.userPreferences.coordinates == "dms" ? decimalToDMS(lat.toFixed(6), true) : lat.toFixed(6)
        this.longitudeRef.current.value = this.props.userPreferences.coordinates == "dms" ? decimalToDMS(lng.toFixed(6)) : lng.toFixed(6)
        this.latitude = this.props.userPreferences.coordinates == "dms" ? decimalToDMS(lat.toFixed(6), true) : lat.toFixed(6)///pavan
        this.longitude = this.props.userPreferences.coordinates == "dms" ? decimalToDMS(lng.toFixed(6)) : lng.toFixed(6)
      }
      this.advanceMarker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
    })


    this.clickListener = google.maps.event.addListenerOnce(mapReference, 'click', (e) => {
      const lat = Math.round(e.latLng.lat() * 1000000) / 1000000,
        lng = Math.round(e.latLng.lng() * 1000000) / 1000000
      if (this.latitudeRef.current && this.longitudeRef.current) {
        this.latitudeRef.current.value = lat
        this.longitudeRef.current.value = lng
        this.latitude = lat.toFixed(6)
        this.longitude = lng.toFixed(6)
      }
      Elevation.getElevation(lat, lng, token)
        .then(res => {
          this.setState({ altitude: res }, () => {
            if (this.props.type === 'addStand') {
              const { mapReference, user, markerTypes25 } = this.props,
                { altitude, latitude, longitude, name, notes, markerTypeId, selectAnimalIcon } = this.state,
                markerType = markerTypes25.find(type => type.id === this.state.markerTypeId),
                userId = user.id,
                toSave = {
                  altitude,
                  name,
                  notes,
                  latitude,
                  longitude,
                  userId,
                  color: this.state.colorMarker,
                  markerTypeId,
                  markerType: {
                    iconUrl: selectAnimalIcon,
                    name: markerType.name,
                    vectorIconUrl: selectAnimalIcon
                  },
                  public: false
                }
              mapReference.setCenter(e.latLng)
              mapReference.setZoom(17)
              this.props.setMarkerData(toSave)
            }
          })
        })
        .catch(() => {
          if (this.props.type === 'addStand') {
            const { mapReference, user, markerTypes25 } = this.props,
              { altitude, latitude, longitude, name, notes, markerTypeId, selectAnimalIcon } = this.state,
              markerType = markerTypes25.find(type => type.id === this.state.markerTypeId),
              userId = user.id,
              toSave = {
                altitude,
                name,
                notes,
                latitude,
                longitude,
                userId,
                markerTypeId,
                color: this.state.colorMarker,
                markerType: {
                  iconUrl: selectAnimalIcon,
                  name: markerType.name,
                  vectorIconUrl: selectAnimalIcon
                },
                public: false
              }
            mapReference.setCenter(e.latLng)
            mapReference.setZoom(17)
            this.props.setMarkerData(toSave)
          }
        })
      this.setState({ latitude: lat, longitude: lng, locationSet: true })
      this.advanceMarker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
      this.removeMouseHandlers()
    })
  }

  removeMouseHandlers() {
    const { mapReference, unBlockFeatures } = this.props
    if (this.props.disableMapObj) {
      this.props.enableMapObject()
    }
    else {
      this.props.enableMapObject()
    }
    if (this.clickListener !== null) {
      google.maps.event.removeListener(this.clickListener)
      this.clickListener = null
    }
    if (this.moveListener !== null) {
      this.moveListener.remove()
      this.moveListener = null
    }
    mapReference.setOptions({ draggableCursor: 'grab' })
    unBlockFeatures()
  }

  makeTextInput(properties) {
    const { name, width, access, marginLeft } = properties
    let heloValue = !isNil(properties.displayVal) && properties.displayVal && properties.displayVal.length > 2 ? properties.displayVal : this.state[name]
    let dmsValue = heloValue && (name === 'latitude' || name === 'longitude') && decimalToDMS(heloValue, name === 'latitude')
    let usageValue = () => {
      if (name == 'latitude' || name === 'longitude') {
        if (this.props.userPreferences.coordinates == "dms") {
          return dmsValue
        } else {
          return heloValue
        }
      } else {
        return heloValue
      }
    }
    return (
      <div style={{ width, height: 68, marginTop: 10, marginLeft }} key={`markerInput-${properties.name}`}>
        <label htmlFor={name}
          className='label-style'
          style={{
            fontSize: '12px',
            textTransform: 'capitalize'
          }}>{`${name}:`}</label>
        <input type='text'
          name={name}
          id={name}
          style={{
            background: '#333333 0% 0% no-repeat padding-box',
            opacity: 1,
            marginTop: '5px',
            width: access ? width : '84%',
            height: 40,
            border: 'none',
            borderRadius: 5,
            padding: '0 10px',
          }}
          placeholder={name}
          readOnly={(name == 'latitude' || name === 'longitude') && this.props.userPreferences.coordinates == 'dms'}
          ref={name === 'latitude' ? this.latitudeRef : name === 'longitude' ? this.longitudeRef : null}
          onChange={this.props.userPreferences != 'dns' && this.handleInputChange.bind(this)}
          value={usageValue()}
        />
      </div>
    )
  }

  onChange(e) {
    const { target } = e;
    const { name, value } = target;
    const convertToFloat = (input) => {
      let parsed
      if (input == '' || input == '-' || input == '.') {
        parsed = input == '-' ? '-' : input == '.' ? '.' : 0
      } else {
        parsed = parseFloat(input);
      }
      return parsed == '-' ? '-' : parsed;
    };

    if (name === 'latitude') {
      this.latitude = convertToFloat(value);
    } else if (name === 'longitude') {
      this.longitude = convertToFloat(value);
    }
    const newPos = { lat: isNaN(this.latitude) ? 0 : parseFloat(this.latitude), lng: isNaN(this.longitude) ? 0 : parseFloat(this.longitude) };
    this.advanceMarker.position = newPos;
    this.setState({ [name]: (value) });
  }

  handleInputChange = (e) => {
    const { target } = e;
    let { name, value } = target;
    let newPos;
    const regex = /^-?\d*\.?\d{0,6}$/;
    if (!regex.test(value)) {
      if (name === 'latitude' || name === 'longitude')
        return;
    }
    if (name === 'latitude') {
      if (value.length > 1) {
        this.latitude = parseFloat(value);
      }
    } else if (name === 'longitude') {
      if (value.length > 1) {
        this.longitude = parseFloat(value);
      }
    }
    newPos = { lat: isNaN(this.latitude) ? 0 : parseFloat(this.latitude), lng: isNaN(this.longitude) ? 0 : parseFloat(this.longitude) };
    this.props.mapReference.setCenter(newPos);
    this.advanceMarker.position = newPos;
    this.setState({ [name]: value });
  };

  makeCategories() {
    const { categories } = this
    return (
      <div key='markerCategories'
        style={{ marginTop: '10px' }}>
        <label htmlFor='category'
          style={{ fontSize: '12px' }}>Category:
          <Select name='category'
            id='category'
            className='marker-selection'
            onChange={(e) => {
              const category = categories.find(category => category.id == e.target.value)
              this.setState({ category })
            }}
            value={this.state.category.id}>
            {
              categories.sort((a, b) => a.order - b.order).map(category => {
                return (
                  <MarkerSelectItem
                    key={`markerCategory-${category.id}`}
                    value={category.id}>
                    <div className='marker-selection-type'
                      style={{
                        paddingLeft: '5px'
                      }}>
                      {category.name}
                    </div>
                  </MarkerSelectItem>
                )
              })
            }
          </Select>
        </label>
      </div>
    )
  }

  makeIconSelection() {
    const { category } = this.state,
      { markerType } = category
    return (
      <div key='markerTypes'
        style={{ marginTop: '10px' }}>
        <label htmlFor='category'
          style={{ fontSize: '12px' }}>Marker:
          <Select name='iconSelection'
            id='iconSelection'
            className='marker-selection'
            onChange={(e) => {
              const selectedMarker = this.props.markerTypes25.find(type => type.id == e.target.value)
              this.setState({ markerTypeId: selectedMarker.id }, () => {
                this.marker.setIcon(
                  selectedMarker.iconUrl
                )
              })
            }}
            value={this.state.markerTypeId}>
            {
              markerType.sort((a, b) => a.order - b.order).map(type => {
                return (
                  <MarkerSelectItem
                    id={type.name}
                    name={type.name}
                    key={`markerType-${type.id}`}
                    value={type.id}>
                    <div className='marker-selection-type'>
                      <div className='marker-selection-icon'>
                        <img className='center'
                          style={{ height: '25px' }}
                          src={`${encodeURI(type.iconUrl)}`}
                        ></img>
                      </div>
                      <div>{type.name}</div>
                    </div>
                  </MarkerSelectItem>
                )
              })
            }
          </Select>
        </label>
      </div >
    )
  }

  markerIconStyle(dropdownHeight, backgroundColorProp, iconProp) {
    const { colorMarker, selectAnimalIcon, selectedStyle, typeOfProp } = this.state;
    const { markerGroups, type } = this.props;
    const gridContainerStyle = {
      marginTop: '5px',
      display: 'grid',
      height: '250px',
      gridTemplateColumns: 'repeat(4, 1fr)', // 4 columns
      gridTemplateRows: 'repeat(4, 1fr)',    // 4 rows
      gap: '8px', // Adjust the gap between cells as neededthis.marker
      alignItems: 'center',
      justifyItems: 'center',
    };

    let standFilterData = []
    if (type === "addStand" || typeOfProp === "addStand") {
      let dataFilter = markerGroups.filter(value => {
        let valueFilter = value.markerType.filter(item => {
          if (item.usageFlag == 3)
            standFilterData.push(value)
        })

      })
    }
    const uniqueArray = Array.from(new Set(standFilterData.map(JSON.stringify))).map(JSON.parse);
    let markerGroupsArray = type === 'addStand' || typeOfProp === "addStand" ? uniqueArray : markerGroups

    const selectColor = (value) => {
      this.setState({ colorMarker: value })
      this.advanceMarker.content = this.buildContent(this.state.selectAnimalIcon, value)
    }

    const selectAnimal = async (value) => {
      this.setState({ selectAnimalIcon: value.vectorIconUrl, markerTypeId: value.id, locationName: value.name })
      this.advanceMarker.content = this.buildContent(value.vectorIconUrl, backgroundColorProp)
    }

    let markerDisplayCOlor = backgroundColorProp[0] == '#' ? backgroundColorProp : '#' + backgroundColorProp
    if (backgroundColorProp) {
      if (backgroundColorProp.length <= 6) {
        markerDisplayCOlor = backgroundColorProp[0] == '#' ? backgroundColorProp : '#' + backgroundColorProp
      } else {
        markerDisplayCOlor = backgroundColorProp[0] == '#' ? backgroundColorProp : '#' + backgroundColorProp.substring(backgroundColorProp.length == 7 ? 1 : 2)
      }
    } else {
      markerDisplayCOlor = '#9ECC3B'
    }
    return (
      <div style={{}} >
        <label className='label-style'> Styles</label>
        <div className='marker-icon-style-container'  >

          <div className='marker-icon-style-container-two'>
            <div className='marker-icon-div'>
              <div
                className='open-style-icon' >
                <a onClick={() => this.setState({ openStyleIcon: !this.state.openStyleIcon })}>
                  <img src={!this.state.openStyleIcon ? rightIcon : downIcon} style={{ color: 'red', width: 17, height: 18, color: 'white' }} />
                </a>
              </div>
              <div className='color-marker-style'>
                <svg width="55px" height="55px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  {/* Define the clipping path for the circle */}
                  <defs>
                    <clipPath id="circleClip">
                      <circle cx="8" cy="6" r="5" />
                    </clipPath>
                  </defs>

                  <rect width="16" height="16" id="icon-bound" fill="none"></rect>
                  <path d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z" fill={markerDisplayCOlor}></path>
                  <circle cx="8" cy="6" r="5" fill="#FFFFFF"></circle>

                  {/* Image inside the circle with clipping path */}
                  <image xlinkHref={iconProp} x="5" y="3" width="6" height="6" clipPath="url(#circleClip)"></image>
                </svg>
                <h6 style={{ font: 'normal normal normal 15px/20px Roboto', color: '#333333' }}>Location</h6>
              </div>
            </div>

            {this.state.openStyleIcon && (

              <div
                style={{ height: dropdownHeight, marginTop: 10, marginLeft: 10 }}
              >
                <div className='select-color-container' style={{ display: 'flex', flexWrap: 'wrap', height: '90px', width: '96%', marginLeft: '6px', marginRight: '6px' }}>
                  {ColorCodes.map((item, index) => {
                    return (
                      <div key={index} style={{ width: 'calc(14.28% - 10px)', height: '40px', margin: '5px' }}>
                        <a onClick={() => selectColor(item)}>
                          <div style={{ width: '30px', height: '20px', borderRadius: '5px', backgroundColor: '#' + item }}></div>
                        </a>
                      </div>
                    );
                  })}
                </div>

                {<>
                  <label className='label-style'
                    style={{}}>  {type === 'addStand' ? 'Hunt Stands' : selectedStyle == 'Recent' ? selectedStyle + ' Used' : selectedStyle}</label>
                  <div className='recent-use-container' >
                    {markerGroupsArray.map((item) => {
                      return (
                        item.name == selectedStyle &&
                        <>
                          <div className="scroll-container">
                            {item.markerType.map((value) => {
                              return (
                                <div
                                  style={{ width: '70px', height: 80, marginTop: 8, display: 'row' }}
                                >
                                  <div className='recent-used-icon-div' style={{ height: type == 'addStand' || typeOfProp == 'addStand' ? '90px' : '90px' }}>

                                    <div className={this.state.markerTypeId == value.id ? 'icon-style-effect-active' : 'icon-style-effect'}>
                                      <a onClick={() => { selectAnimal(value) }}>
                                        <img src={value.vectorIconUrl} style={{ width: '30px', height: ' 25px', }}></img>
                                      </a>
                                    </div>
                                    <span className='recent-used-label' style={{ width: type == 'addStand' || typeOfProp == 'addStand' ? 60 : 60, height: type == 'addStand' || typeOfProp == 'addStand' ? '30px' : '30px', textAlign: 'center' }}>{value.name}</span>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        </>
                      )
                    })}
                  </div>
                </>}

                {type === "addStand" || typeOfProp === "addStand" ?
                  ''
                  :
                  <>
                    <label className='label-style' style={{ marginTop: '10px' }}> All Styles </label>
                    <div style={gridContainerStyle}>
                      {markerGroupsArray.map((item) => {
                        const onClickFilter = (value) => {
                          this.setState({ filterItems: value.id, selectedStyle: value.name })
                        }
                        return (
                          <div>
                            <a>
                              <div className='all-styles-container ' onClick={() => onClickFilter(item)}>
                                <spam className="marker-styles-group-header" style={{}}>{item.name}</spam>
                              </div>
                            </a>
                          </div>
                        )
                      })}
                    </div>
                  </>
                }
              </div>
            )}
          </div>
        </div>
      </div>

    )

  }

  recentUsedMarkers() {
    const { colorMarker, selectAnimalIcon, selectedStyle, typeOfProp } = this.state;
    const { markerGroups, markers } = this.props;
    let recentUsedMarkers = [];
    let seenTypes = new Set();
    // Step 1: Add one marker from `filterGroup` (with id = 1) to recentUsedMarkers if available
    const filterGroup = markerGroups.find(item => item.id === 1);
    if (filterGroup) {
      let val = { markerType: filterGroup.markerType[0] }
      // recentUsedMarkers.push(filterGroup);
      recentUsedMarkers.push(val);
    }
    markers
      .sort((a, b) => new Date(b.created) - new Date(a.created)) // Sort by created date in descending order
      .forEach(marker => {
        // Skip if marker's id is 1 or if it has already been added
        if (marker.markerType.id !== 134 && !seenTypes.has(marker.markerType.id) && recentUsedMarkers.length < 5) {
          seenTypes.add(marker.markerType.id);
          recentUsedMarkers.push(marker);
        }
      });
    // Update the state if recentUsedMarkers is populated
    if (recentUsedMarkers.length > 0) {
      this.setState({
        recentUsedMarkers,
      });
    }
  }

  newMarkerIconStyle(dropdownHeight, backgroundColorProp, iconProp) {
    const { selectedStyle, typeOfProp, recentUsedMarkers } = this.state;
    const { markerGroups, type } = this.props;
    const { editable, mapObj } = this.props.leftToolbarState
    const gridContainerStyle = {
      marginTop: '5px',
      display: 'grid',
      gap: '8px', // Adjust the gap between cells as neededthis.marker
      alignItems: 'center',
      justifyItems: 'center',
    };

    let standFilterData = []
    if (type === "addStand" || typeOfProp === "addStand") {
      let dataFilter = markerGroups.filter(value => {
        let valueFilter = value.markerType.filter(item => {
          if ((item.usageFlag == 3))
            standFilterData.push(value)
        })

      })
    }
    const uniqueArray = Array.from(new Set(standFilterData.map(JSON.stringify))).map(JSON.parse);
    let markerGroupsArray = type === 'addStand' || typeOfProp === "addStand" ? uniqueArray : markerGroups

    const selectColor = (value) => {
      this.setState({ colorMarker: value })
      this.advanceMarker.content = this.buildContent(this.state.selectAnimalIcon, value)
    }

    const selectAnimal = async (value) => {
      this.setState({ selectAnimalIcon: value.vectorIconUrl, markerTypeId: value.id, locationName: value.name })
      this.advanceMarker.content = this.buildContent(value.vectorIconUrl, backgroundColorProp)
    }

    let markerDisplayCOlor = backgroundColorProp[0] == '#' ? backgroundColorProp : '#' + backgroundColorProp
    if (backgroundColorProp) {
      if (backgroundColorProp.length <= 6) {
        markerDisplayCOlor = backgroundColorProp[0] == '#' ? backgroundColorProp : '#' + backgroundColorProp
      } else {
        markerDisplayCOlor = backgroundColorProp[0] == '#' ? backgroundColorProp : '#' + backgroundColorProp.substring(backgroundColorProp.length == 7 ? 1 : 2)
      }
    } else {
      markerDisplayCOlor = '#9ECC3B'
    }

    return (
      <div style={{}} >
        <label className='label-style'> Styles</label>
        <div className='marker-icon-style-container'>
          <div className='marker-icon-style-container-two' style={{ backgroundColor: !this.state.openStyleIcon ? '#333333' : 'white' }}    >
            <div className='marker-icon-div'>
              <div
                className='open-style-icon' >
                <a onClick={() => this.setState({ openStyleIcon: !this.state.openStyleIcon })}>
                  <img src={!this.state.openStyleIcon ? rightIcon : downIcon} style={{ color: 'red', width: 17, height: 18, color: 'white' }} />
                </a>
              </div>
              <div className='color-marker-style'>
                <svg width="55px" height="55px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  {/* Define the clipping path for the circle */}
                  <defs>
                    <clipPath id="circleClip">
                      <circle cx="8" cy="6" r="5" />
                    </clipPath>
                  </defs>

                  <rect width="16" height="16" id="icon-bound" fill="none"></rect>
                  <path d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z" fill={markerDisplayCOlor}></path>
                  <circle cx="8" cy="6" r="5" fill="#FFFFFF"></circle>

                  {/* Image inside the circle with clipping path */}
                  <image xlinkHref={iconProp} x="5" y="3" width="6" height="6" clipPath="url(#circleClip)"></image>
                </svg>
                <h6 style={{ font: ' normal normal normal 15px/20px Roboto', color: !this.state.openStyleIcon ? '' : '#333333' }}>{this.state.locationName}</h6>
              </div>
            </div>

            {this.state.openStyleIcon && (
              <div
                style={{ height: dropdownHeight, marginTop: 10, marginLeft: 10 }}
              >
                <div className='select-color-container' style={{ display: 'flex', flexWrap: 'wrap', height: '90px', width: '96%', marginLeft: '6px', marginRight: '6px' }}>
                  {ColorCodes.map((item, index) => {
                    return (
                      <div key={index}
                        style={{
                          width: 'calc(14.28% - 10px)', height: '40px', margin: '5px',
                        }}>
                        <a style={{
                        }}>
                          <div className='selected-color'
                            onClick={(e) => {
                              e.preventDefault()
                              selectColor(item)
                            }}
                            style={{
                              backgroundColor: '#' + item,
                            }}></div>
                        </a>
                        <div className={item === this.state.colorMarker ? 'bottom-box' : ''}></div>
                      </div>
                    );
                  })}
                </div>

                <div className='marker-icons-style' style={{ overflowY: editable || type === 'addStand' ? 'none' : 'scroll' }}>
                  {<>
                    <label className="label-all-style">  {type === 'addStand' ? 'Hunt Stands' : selectedStyle == 'Recent' ? selectedStyle + ' Used' : selectedStyle}</label>
                    <div className='recent-use-container' >
                      {markerGroupsArray.map((item, index) => {
                        return (
                          item.name == selectedStyle &&
                          <>
                            <div className="scroll-container">
                              {selectedStyle == 'Hunt Stands' || recentUsedMarkers.length < 1 ? item.markerType.map((value, index) => {
                                return (
                                  <div key={index} style={{ width: '60px', height: 80, marginTop: 8, display: 'row' }}>
                                    <div className='recent-used-icon-div' style={{ height: type == 'addStand' || typeOfProp == 'addStand' ? '80px' : '80px' }}>
                                      <div className={this.state.markerTypeId == value.id ? 'icon-style-effect-active' : 'icon-style-effect'}>
                                        <a onClick={() => { selectAnimal(value) }}>
                                          <img src={value.vectorIconUrl} style={{ width: '30px', height: ' 25px', }}></img>
                                        </a>
                                      </div>
                                      <span className='recent-used-label' style={{ width: type == 'addStand' || typeOfProp == 'addStand' ? 60 : 60, height: type == 'addStand' || typeOfProp == 'addStand' ? '30px' : '30px', textAlign: 'center', color: '#333333' }}>{value.name}</span>
                                    </div>
                                  </div>
                                )
                              }) :
                                recentUsedMarkers.map((value, index) => {
                                  return (
                                    <div key={index} style={{ width: '60px', height: 80, marginTop: 8, display: 'row' }}>
                                      <div className='recent-used-icon-div' style={{ height: type == 'addStand' || typeOfProp == 'addStand' ? '80px' : '80px' }}>
                                        <div className={this.state.markerTypeId == value.markerType.id ? 'icon-style-effect-active' : 'icon-style-effect'}>
                                          <a onClick={() => { selectAnimal(value.markerType) }}>
                                            <img src={value.markerType.vectorIconUrl} style={{ width: '30px', height: ' 25px', }}></img>
                                          </a>
                                        </div>
                                        <span className='recent-used-label' style={{ width: type == 'addStand' || typeOfProp == 'addStand' ? 60 : 60, height: type == 'addStand' || typeOfProp == 'addStand' ? '30px' : '30px', textAlign: 'center', color: '#333333' }}>{value.markerType.name}</span>
                                      </div>
                                    </div>
                                  )
                                })}
                            </div>
                          </>
                        )
                      })}
                    </div>
                  </>}

                  {type === "addStand" || typeOfProp === "addStand" ?
                    ''
                    :
                    <>
                      <label className='label-all-style' > All Styles </label>
                      <div>
                        {markerGroupsArray.map((item, index) => {
                          const onClickFilter = (value) => {
                            this.setState({ filterItems: value.id, selectedStyle: value.name })
                          }
                          let gridRowSize = item.markerType.length <= 4 ? 1 : item.markerType.length <= 8 ? 2 : item.markerType.length <= 12 ? 3 : item.markerType.length <= 16 ? 4 : item.markerType.length <= 20 ? 5 : item.markerType.length <= 24 ? 6 : item.markerType.length <= 28 ? 7 : 4
                          let heightGrid = item.name == "Wildlife" ? 1340 : item.name == "Hunting" ? 1040 : item.name == "Fishing" ? 550 : item.markerType.length <= 4 ? 80 : gridRowSize * 85
                          return (
                            <>
                              {item.name != "Recent" && item.name != "Hunt Stands" &&
                                <div key={index}>
                                  <a>
                                    <div className='all-styles-container'
                                      style={{ marginTop: 15 }}>
                                      <spam className="marker-styles-group-header" style={{}}>{item.name}</spam>
                                    </div>
                                  </a>
                                  <div style={{
                                    ...gridContainerStyle,
                                    height: heightGrid,
                                    gridTemplateColumns: `repeat(${4}, 1fr)`, // 4 columns
                                    gridTemplateRows: `repeat(${gridRowSize}, 1fr)`,
                                  }}>
                                    {item.markerType.map((value, index) => {
                                      return (
                                        <div key={index} style={{ width: '60px', height: 80, marginTop: 8, display: 'row' }}>
                                          <div className='recent-used-icon-div' style={{ height: type == 'addStand' || typeOfProp == 'addStand' ? '80px' : '80px' }}>
                                            <div className={this.state.markerTypeId == value.id ? 'icon-style-effect-active' : 'icon-style-effect'}
                                              onClick={(e) => {
                                                e.preventDefault()
                                                selectAnimal(value)
                                              }}
                                            >
                                              <a >
                                                <img src={value.vectorIconUrl} style={{ width: '30px', height: ' 25px', }}></img>
                                              </a>
                                            </div>
                                            <span className='recent-used-label' style={{ width: type == 'addStand' || typeOfProp == 'addStand' ? 60 : 60, height: type == 'addStand' || typeOfProp == 'addStand' ? '30px' : '30px', textAlign: 'center', color: '#333333' }}>{value.name}</span>
                                          </div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>}
                            </>
                          )
                        })}
                      </div>
                    </>
                  }
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    )
  }

  removeMarker() {
    const { markerDeleteRequest, leftToolbarState, collapseLeftToolbar, enableMapObject } = this.props,
      { editable } = leftToolbarState
    markerDeleteRequest(editable.id).then(() => {
      this.marker.setMap(null)
      this.advanceMarker.map = null
      collapseLeftToolbar()
      enableMapObject()
    })
  }

  cancelRemoval() {
    this.setState({ confirmRemoval: false })
  }

  getHeader() {
    const { markerTypes105, leftToolbarState, usageFlag, userPreferences } = this.props,
      { editable } = leftToolbarState,
      { locationSet, altitude } = this.state,
      lat = Math.round(this.state.latitude * 1000000) / 1000000,
      lng = Math.round(this.state.longitude * 1000000) / 1000000,
      markerTypeDetails = markerTypes105.find(type => type.id === this.state.markerTypeId),
      iconStyles = {
        fontSize: '24px',
        height: '24px',
        position: 'relative',
        top: '5px',
        float: 'right',
        marginTop: -22
      }
    let altitudeValue = userPreferences.units == 'imperial' ? (altitude * 3.28084).toFixed(6) + ' ' + 'fts' : altitude + ' ' + 'mts'
    return (
      <div>
        <div className='tools-header'>
          <div style={{
            width: '100%',
            height: 56,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: -60
          }}>
            <div style={{
              border: '2px solid #589500',
              borderRadius: 5,
              width: 35,
              height: 35,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 10
            }}>
              <img src={this.props.type === "addStand" || editable && (editable.markerType.usageFlag == 3) ? standIcon : standIconWhite} style={{}}></img>
            </div>
            {(this.props.type === 'addStand')
              ? 'Add Stand'
              : (editable && (editable.markerType.usageFlag == 3))
                ? 'Edit Stand'
                : (this.props.type !== 'addStand' && !editable)
                  ? 'Add Marker' :
                  (editable && editable.SharedMarker) ?
                    'Add Shared Marker'
                    : 'Edit Marker'}
          </div>
          {editable && editable.SharedMarker ? '' :
            <>
              {locationSet ? <Lock onClick={() => {
                this.setState({ locationSet: false }, () => {
                  this.advanceMarker.element.style.pointerEvents = 'none';
                  this.addMouseHandlers()
                })
              }}
                style={iconStyles} /> :
                <LockOpen
                  style={iconStyles}
                  onClick={() => {
                    this.setState({ locationSet: true }, () => {
                      this.removeMouseHandlers()
                    })
                  }} />
              }
            </>
          }
        </div>
      </div>
    )
  }

  cancleClose(editable) {
    if (editable) {
      if (this.state.latitude != editable.latitude.toFixed(6)) {
        this.setState({ discardPopUp: true })
      } else if (this.state.longitude != editable.longitude.toFixed(6)) {
        this.setState({ discardPopUp: true })
      } else if (this.state.name != editable.name) {
        this.setState({ discardPopUp: true })
      } else if (this.state.notes != editable.notes) {
        this.setState({ discardPopUp: true })
      } else if (this.state.colorMarker != editable.color) {
        this.setState({ discardPopUp: true })
      } else if (this.state.selectAnimalIcon != editable.markerType.vectorIconUrl) {
        this.setState({ discardPopUp: true })
      } else {
        // this.setState({ discardPopUp: true })
        this.props.collapseLeftToolbar()
        this.props.enableMapObject()
      }
    } else {
      this.props.collapseLeftToolbar()
      this.props.enableMapObject()
    }
  }

  discardChange(editable) {
    if (editable) {
      this.advanceMarker.position = { lat: parseFloat(editable.latitude), lng: parseFloat(editable.longitude) }
      this.advanceMarker.content = this.buildContent(editable.markerType.vectorIconUrl, editable.color)
      if (editable.SharedMarker) {
        this.advanceMarker.map = null
      }
    }
    this.props.collapseLeftToolbar()
    this.props.enableMapObject()
  }

  closePopUp() {
    this.setState({ discardPopUp: false })
  }

  weatherDataFunction() {
    let data = { lat: this.latitude, lng: this.longitude }
    this.props.weatherData(data, (res) => {
      this.setState({ weatherData: res })
    })
  }

  render() {
    const { leftToolbarState, collapseLeftToolbar, enableMapObject, markerDeleteRequest, type, markerTypes25FetchRequest, userPreferences } = this.props,
      { editable } = leftToolbarState,
      { locationSet, openStyleIcon, filterItems, selectAnimalIcon, colorMarker, typeOfProp, createdDate, updatedDate, loadSpinner } = this.state,
      height = `calc(100vh - ${editable ? '185px' : '340px'})`,
      hasCoords = this.state.latitude && this.state.longitude ? true : false
    const dropdownHeight = openStyleIcon ? type === 'addStand' || typeOfProp === 'addStand' ? 270 : 400 : 0;
    const iconUrl = selectAnimalIcon ? selectAnimalIcon : ''
    const markerColor = colorMarker ? colorMarker : ''

    let backgroundColor = loadSpinner
      ? 'grey'
      : (hasCoords || locationSet)
        ? '#589500'
        : 'grey';
    return (
      <div className='tools-content'>
        {loadSpinner &&
          <div className='markers-load-spinner'>
            <div class="loader-spinner"></div>
          </div>
        }

        <div style={{
          width: '100%',
          height: 56,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: -60
        }}>
        </div>
        {this.getHeader()}
        <div className='container-box' >
          <div className='container-box-two'
            style={{ overflowY: editable || type === 'addStand' ? 'none' : 'scroll', height: !editable && 'calc(100vh - 145px)' }}
          >
            {editable && <div>
              <h5>Created&nbsp;:&nbsp;&nbsp;{createdDate}</h5>
            </div>}
            {editable && updatedDate && <div style={{ marginTop: '10px' }}>
              <h5>Updated&nbsp;:&nbsp;&nbsp;{updatedDate}</h5>
            </div>}
            {this.makeTextInput({ name: 'name', width: '96.2%', access: true })}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '10px',
            }}>
              {[
                this.makeTextInput({ name: 'latitude', width: '95%', displayVal: this.latitude, access: false, }),
                this.makeTextInput({ name: 'longitude', width: '95%', displayVal: this.longitude, access: false, marginLeft: 10 })
              ]}
            </div>
            {this.newMarkerIconStyle(dropdownHeight, markerColor, iconUrl)}
            {
              editable && (editable.markerType.usageFlag == 3) ? <div style={{ position: 'relative', top: dropdownHeight, marginBottom: 20 }}><ExtendedData marker={editable} dropdownHeight={dropdownHeight} /> </div> : null
            }
            <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', top: dropdownHeight, marginBottom: 20 }}>
              <label htmlFor='notes'
                className='label-style'
                style={{ marginBottom: 10 }}>Notes:
              </label>
              <textarea name='notes'
                id='notes'
                className='marker-notes'
                onChange={this.onChange.bind(this)}
                value={this.state.notes}
                style={{
                  height: this.props.type === "addStand" || editable && (editable.markerType.usageFlag == 3) ? '70px' : editable ? '70px' : '150px',
                  background: ' #333333 0% 0% no-repeat padding-box',
                  borderRadius: 5,
                  opacity: 1,
                  border: 'none',
                  width: '99%'
                }}
              />
            </div >
            {editable && editable.weatherObservation &&
              <div style={{ position: 'relative', top: dropdownHeight, marginBottom: 20 }}>
                <label htmlFor='notes'
                  className='label-style'
                  style={{ marginBottom: 10 }}>SmartMarker&#8482; Data:
                </label>
                <div className='marker-weather-container'>
                  <div style={{ width: '100%', height: '100%' }}>
                    <div className='weather-data-header' >
                      <p style={{}}>Weather Data</p>
                    </div>
                    <div className='weather-data-value' >
                      <div style={{ display: 'flex' }}>
                        <h1>{`${userPreferences.units == "imperial" ? editable && editable.weatherObservation && editable.weatherObservation.weatherObservation.tempF : Math.round((editable && editable.weatherObservation && editable.weatherObservation.weatherObservation.tempF - 32) / 1.8)}\u00B0`}</h1><p>{userPreferences.units == "imperial" ? 'F' : 'C'}</p>
                        <img src={editable && editable.weatherObservation && (editable.weatherObservation.weatherObservation.baseIconUrl + editable.weatherObservation.weatherObservation.weatherIcon)}
                          style={{ width: 20, height: 20, marginLeft: 20 }}
                        ></img>
                        <p style={{ marginLeft: 5, marginTop: 2 }}>{editable && editable.weatherObservation && editable.weatherObservation.weatherObservation.weatherPrimary}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        {
          // type !== 'addStand'
          true ? (
            <div style={{
              width: '95%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              position: 'relative',
              bottom: 0,
              margin: '0',
              padding: '10px', // Optional: Add padding for better visibility
              top: '10px'
            }}>
              <button onClick={() => this.cancleClose(editable)}
                style={{
                  width: '40%',
                  margin: '0',
                  backgroundColor: 'grey'
                }}>Cancel</button>
              <button style={{
                width: '40%',
                margin: '0',
                backgroundColor: backgroundColor
              }}
                onClick={this.saveMarker.bind(this)}>Save Changes</button>
            </div>
          ) : null
        }
        {this.state.confirmRemoval ? <ConfirmRemoval
          remove={this.removeMarker.bind(this)}
          cancel={this.cancelRemoval.bind(this)}
          type='marker' /> : null}
        {this.state.discardPopUp ?
          <DiscardChanges cancel={() => this.closePopUp()} discard={() => this.discardChange(editable)} ></DiscardChanges>
          :
          null}
      </div >
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  leftToolbarState: state.leftToolbarState,
  mapReference: state.mapReference(),
  markerGroups: state.markerGroups,
  // markers: state.markers,
  markerTypes25: state.markerTypes25,
  markerTypes35: state.markerTypes35,
  markerTypes105: state.markerTypes105,
  user: state.user,
  disableMapObj: state.disableMapObj,
  userPreferences: state.userPreferences,
  markerCenter: state.markerCenter,
  vendors: state.vendors,
  auth: state.auth,
  infoWindow: state.infoWindow,
  markers: state.markers.filter(marker => marker &&
    marker.markerType.usageFlag != 3),
  huntStands: state.markers.filter(marker => (marker && marker.markerType.usageFlag == 3)
  ),
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: (properties) => dispatch(expandLeftToolbar(properties)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  enableMapObject: () => dispatch(enableMapObject()),
  disableMapObject: () => dispatch(disableMapObject()),
  markerCreateRequest: marker => dispatch(markerCreateRequest(marker)),
  markerDeleteRequest: id => dispatch(markerDeleteRequest(id)),
  markerUpdateRequest: marker => dispatch(markerUpdateRequest(marker)),
  blockFeatures: () => dispatch(blockFeatures()),
  unBlockFeatures: () => dispatch(unBlockFeatures()),
  markerTypes25FetchRequest: () => dispatch(markerTypes25FetchRequest()),
  removeCenterMarker: () => dispatch(removeCenterMarker()),
  weatherUpdate: (data) => dispatch(weatherUpdate(data)),
  weatherData: (data, callback) => dispatch(weatherData(data, callback)),
  markerGroupsFetchRequest: () => dispatch(markerGroupsFetchRequest())
})

export default connect(mapStateToProps, mapDispatchToProps)(MarkerDetails)